import React from "react";
import { Typography, Box, MenuItem, Select } from "@material-ui/core";
import { useTranslation } from "@/langs/useTranslation";
import styles from "./index.module.less";
import ConfigSwitch from "../AndroidConfig/common/ConfigSwitch";
import Countries from "@/assets/ISO3166";
import countryTimezone from "country-timezone";
import { makeStyles } from "@material-ui/core/styles";
import windowsLang from "@/assets/windowsLang";
import { generateIntlHash } from "@/helpers/utils";

const SystemConfig = ({ values, onChange, readOnly }) => {
  const { t } = useTranslation();
  const tt = t;

  return (
    <Box flex={1}>
      <div style={{display: "flex", alignItems: "center"}}>
        <Typography variant="h5" style={{ marginBottom: 32 }}>
          {t({ defaultMessage: "系统设置" })}
        </Typography>
        <Typography variant="subtitle" style={{ marginLeft: 8, marginBottom: 32 }}>
          {t({ defaultMessage: "(应用设置后设备将会自动重启)" })}
        </Typography>
      </div>
      <ConfigSwitch
        title={t({ defaultMessage: "是否启用" })}
        name="systemSetting.open"
        onChange={onChange}
        marginBottom={3}
        value={values.open}
      />
      {values.open && (
        <>
          <div className={styles.card}>
            <Typography variant="h5">
              {t({ defaultMessage: "时间" })}
            </Typography>
            <ConfigSwitch
              marginTop={3}
              title={t({ defaultMessage: "手动设置时区" })}
              name="systemSetting.time.manual"
              onChange={onChange}
              value={values.time.manual}
            />
            {values.time.manual && (
              <>
                <Typography
                  variant="h6"
                  style={{ marginTop: 24, marginBottom: 16 }}
                >
                  {t({ defaultMessage: "区域" })}
                </Typography>
                <Select
                  name="systemSetting.time.region"
                  variant="outlined"
                  value={values.time.region}
                  fullWidth
                  className={styles.select}
                  // onChange={onChange}
                  onChange={e => {
                    onChange(e);
                    onChange({
                      target: {
                        name: "systemSetting.time.timezone",
                        value: countryTimezone.getTimezonesWithCountryCode(
                          e.target.value
                        )[0]
                      }
                    });
                  }}
                  disabled={readOnly}
                >
                  {Countries.map(country => {
                    return (
                      <MenuItem value={country.alpha2} key={country.alpha3}>
                        {tt({id: generateIntlHash(country.translation)})}
                      </MenuItem>
                    );
                  })}
                </Select>
                <Typography
                  variant="h6"
                  style={{ marginTop: 24, marginBottom: 16 }}
                >
                  {t({ defaultMessage: "时区" })}
                </Typography>
                <Select
                  name="systemSetting.time.timezone"
                  variant="outlined"
                  value={values.time.timezone}
                  fullWidth
                  className={styles.select}
                  onChange={onChange}
                  disabled={readOnly}
                >
                  {countryTimezone
                    .getTimezonesWithCountryCode(values.time.region)
                    .map(tz => {
                      return (
                        <MenuItem value={tz} key={tz}>
                          {tt({id: generateIntlHash(tz)})}
                        </MenuItem>
                      );
                    })}
                </Select>
              </>
            )}
            <ConfigSwitch
              marginTop={2}
              title={t({ defaultMessage: "启用24小时格式" })}
              name="systemSetting.time.24hour"
              onChange={onChange}
              value={values.time["24hour"]}
            />
            <Typography
              variant="h6"
              style={{ marginTop: 24, marginBottom: 16 }}
            >
              {t({ defaultMessage: "Windows显示语言" })}
            </Typography>
            <Select
              name="systemSetting.time.windows_display_language"
              variant="outlined"
              value={values.time.windows_display_language}
              fullWidth
              className={styles.select}
              onChange={e => {
                onChange({
                  target: {
                    name: "systemSetting.time.windows_display_language",
                    value: e.target.value
                  }
                })
              }}
              disabled={readOnly}
            >
              {windowsLang.map(lang => {
                const v = `${lang.value},${lang.label}`;
                return (
                  <MenuItem value={v} key={v}>
                    {tt({id: generateIntlHash(lang.label)})}
                  </MenuItem>
                );
              })}
            </Select>
          </div>
        </>
      )}
    </Box>
  );
};

const useStyles = makeStyles(theme => ({
  rangeTimePicker: {
    display: "flex",
    marginBottom: theme.spacing(2.5),
    marginTop: 16
  },
  rangeDelimiter: {
    margin: `0 ${theme.spacing(2)}px`,
    alignSelf: "center",
    color: theme.palette.text.secondary
  }
}));

export const initValues = {
  open: false,
  time: {
    manual: true,
    region: "CN",
    timezone: "Asia/Shanghai",
    "24hour": true,
    windows_display_language: "zh-CN,中文"
  }
};
export default SystemConfig;
